import { message } from "antd";

export function convertToDateFormat(dateTimeString) {
  if (dateTimeString) return (dateTimeString?.split("T"))[0];
}

export function getDomainFromLocalStorage() {
  if (typeof window === "undefined") return null;

  const url = localStorage.getItem("WebsiteUrl");
  if (!url) return null;

  return url.replace(/^https?:\/\//, "");
}

function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

function normalizeKeys(obj) {
  if (Array.isArray(obj)) {
    return obj.map(normalizeKeys);
  }
  if (obj !== null && typeof obj === "object") {
    return Object.keys(obj).reduce((acc, key) => {
      const pascalKey = capitalizeFirstLetter(key);
      acc[pascalKey] = normalizeKeys(obj[key]);
      return acc;
    }, {});
  }
  return obj;
}

export default normalizeKeys;



export const copyToClipboard = async (text) => {
  if (!text) return;

  try {
    await navigator.clipboard.writeText(text);
    message.success("Copied");
  } catch (error) {
    message.error("Failed to copy");
  }
};
